const ApiPermissions = {
    None: { text: "None", name: "SCP_None", value: 0, hidden: true },
    //In Game Roles
    GetInGameRoles: { text: "Get In-Game Roles", name: "GetInGameRoles", value: 1 },
    ManageInGameRoles: { text: "Manage In-Game Roles", name: "ManageInGameRoles", value: 2 },
    //Server
    GetServers: { text: "Get Servers", name: "GetServers", value: 4 },
    ManageServers: { text: "Manage Servers", name: "ManageServers", value: 8 },
    GetPlayers: { text: "Get Players", name: "GetPlayers", value: 16 },
    ManagePlayers: { text: "Manage Players", name: "Manage Players", value: 32 },
    GetLogs: { text: "Get Logs", name: "GetLogs", value: 64 },
};

export default ApiPermissions;